<template>
    <div>
        <communities-grid :communities="communities" :loading="loading" />
    </div>
</template>
<script>
import CommunitiesGrid from '@/components/CommunitiesGrid';
import _ from 'underscore';
export default {
    components: {
        CommunitiesGrid,
    },
    props: {
    },
    data() {
        return {
            community: null,
            showModal: false,
            loading: true,
        };
    },

    computed: {
        communities() {
            return this.$store.getters.communities;
        }
    },
    created() {
        this.$store.commit('SET_RENDER_NAVBAR', false);
        document.body.classList.add('pt-0')
    },
    mounted() {
        this.$store
            .dispatch('fetchMyCommunities')
            .catch(() => {
                console.error('failed to fetch communities content');
            })
            .finally(() => {
                this.loading = false;
            });
    },
    beforeDestroy() {
        this.$store.commit('SET_COMMUNITIES', []);
        this.$store.commit('SET_RENDER_NAVBAR', true);
    },
};
</script>


<style scoped>
</style>
